/* @ngInject */
function MyApprovalsTabController ($scope, $rootScope, $translate, $timeout, $q, ApprovalsService, ToastService, WorkflowHeaderService, UserFilterService, UdsModalService, ConfirmationModalService) {
  const getSaveTaskFilterDialogController = () => $q.when(import('../../dialogs/save-task-filter/save-task-filter-dialog.controller'))

  $scope.options = {
    $sort: 'status',
    $order: 'ASC',
    $top: 10,
    $skip: 0
  }

  $scope.items = []
  $scope.count = null
  $scope.overdueCount = null

  $scope.loading = false
  $scope.loadingMore = false

  $scope.selectedFilters = {}
  $scope.selectedQuickFilter = null

  let loadingRequests = true

  const api = {
    getSaveTaskFilterDialogController,
    _getMyApprovals,
    _getMyApprovalsOverdueCount,
    _resetTabObject,
    _setIsFiltering,
    _getUserFilters,
    _openEditUserFilterDialog,
    _openDeleteUserFilterDialog,
    _clearAdvancedFilters,
    _getSelectedFilters,
    _getUserSelectedFilters,
    _getAdvancedSelectedFilters
  }
  this.getApi = () => api

  $translate.onReady(() => {
    $scope.sortOptions = [
      {
        label: $translate.instant('approval'),
        value: 'status',
        active: true
      },
      {
        label: $translate.instant('priorityFilter'),
        value: 'tasks.priority'
      },
      {
        label: $translate.instant('status'),
        value: 'tasks.status'
      }
    ]

    $scope.userFilterOptions = [
      {
        id: 'EDIT',
        label: $translate.instant('edit'),
        value: 'EDIT',
        active: false
      },
      {
        id: 'DELETE',
        label: $translate.instant('delete'),
        value: 'DELETE',
        active: false
      }
    ]
  })

  activate()

  function activate () {
    $scope.filters = WorkflowHeaderService.getMyApprovalsFilters($translate, $rootScope.oUser.locale)
    api._getUserFilters()
  }

  $scope.$watch('isTabSelected', (newVal) => {
    if (newVal) {
      api._resetTabObject()
      api._getMyApprovalsOverdueCount()
      api._getMyApprovals()
    }
  })

  $scope.onChangeSortOrder = () => {
    const sort = $scope.options.$sort
    const order = $scope.options.$order === 'ASC' ? 'DESC' : 'ASC'

    api._resetTabObject()

    $scope.options.$sort = sort
    $scope.options.$order = order

    api._getMyApprovals()
  }

  $scope.onChangeSortSelect = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const value = event?.detail?.value

    if (value) {
      api._resetTabObject()

      $scope.options.$sort = value

      api._getMyApprovals()
    }
  }

  $scope.loadMoreMyApprovals = async () => {
    try {
      $scope.loadingMore = true
      $scope.options.$skip = $scope.options.$skip + $scope.options.$top
      api._getMyApprovals()
    } catch (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    } finally {
      $scope.loadingMore = false
    }
  }

  $scope.onFilter = (filters, hasPreFilters, filtersCount, ignoreSubmit) => {
    if (loadingRequests) {
      loadingRequests = false
      return
    }

    $scope.selectedFilters = filters
    if (ignoreSubmit) return

    $scope.selectedQuickFilter = null
    $('.filters-section uds-pill-select').attr('checked', false)

    api._resetTabObject()
    api._getMyApprovals()
  }

  $scope.onSaveFilter = (filters) => {
    api.getSaveTaskFilterDialogController().then(({ SaveTaskFilterDialogController }) => {
      const saveTaskFilterDialog = UdsModalService.createModal({
        controller: SaveTaskFilterDialogController,
        modalName: 'saveTaskFilterDialog',
        data: {
          selectedFilters: filters,
          allFilters: $scope.filters,
          location: 'my-approvals'
        },
        onClose: (wasCreated) => {
          if (wasCreated) {
            api._getUserFilters()
          }
        }
      })

      saveTaskFilterDialog.open()
    })
  }

  $scope.onUserFilterOptionClick = (event, userFilter) => {
    const option = event.detail?.option?.value

    if (option === 'EDIT') {
      api._openEditUserFilterDialog(userFilter)
    } else if (option === 'DELETE') {
      api._openDeleteUserFilterDialog(userFilter)
    }
  }

  $scope.onUserFilterSelect = (event, userFilter) => {
    if (event.detail?.checked) {
      $scope.selectedQuickFilter = userFilter
    } else {
      $scope.selectedQuickFilter = null
    }

    $(`uds-pill-select:not(.user-filter-${userFilter.id})`).attr('checked', false)

    api._clearAdvancedFilters()
    api._resetTabObject()
    api._getMyApprovals()
  }

  function _clearAdvancedFilters () {
    $scope.$broadcast('advancedSearch.clearAllFilters', true)
  }

  function _getMyApprovalsOverdueCount () {
    return ApprovalsService.getMyApprovalsOverdueCount().then(count => {
      $scope.overdueCount = count
    })
  }

  function _getMyApprovals () {
    $scope.loading = true

    const filters = api._getSelectedFilters()

    api._setIsFiltering($scope.selectedFilters)

    return ApprovalsService.getMyApprovals({
      $top: $scope.options.$top,
      $skip: $scope.options.$skip,
      $sort: $scope.options.$sort,
      $order: $scope.options.$order,
      filters
    }).then(result => {
      $scope.items.push(...result.rows)
      $scope.count = result.count
      $scope.tabCount = result.count
    }).finally(() => {
      $timeout(() => { $scope.loading = false })
    })
  }

  function _resetTabObject () {
    $scope.loading = false
    $scope.loadingMore = false
    $scope.items = []
    $scope.count = null
    $scope.overdueCount = null
    $scope.options.$top = 10
    $scope.options.$skip = 0
    $scope.options.$sort = 'status'
    $scope.options.$order = 'ASC'
  }

  function _setIsFiltering (filters) {
    const filteringActives = filters.isArchived === 'false' || filters.isArchived === false
    const filtersWithValue = UserFilterService.getFiltersWithValue(filters)
    const onlyOneFilter = filtersWithValue.length === 1
    const noFilters = filtersWithValue.length === 0
    $scope.isFiltering = !((onlyOneFilter && filteringActives) || noFilters)
  }

  function _getSelectedFilters () {
    if ($scope.selectedQuickFilter?.userId) {
      return api._getUserSelectedFilters()
    } else {
      return api._getAdvancedSelectedFilters()
    }
  }

  function _getUserSelectedFilters () {
    const filterObj = {}

    $scope.selectedQuickFilter.filterItems.forEach(item => {
      filterObj[item.filter] = item.value
    })

    return filterObj
  }

  function _getAdvancedSelectedFilters () {
    return $scope.selectedFilters
  }

  function _getUserFilters () {
    UserFilterService.getUserFilters('my-approvals').then(filters => {
      $scope.userFilters = filters

      if ($scope.userFilters.length) {
        $scope.selectedQuickFilter = $scope.userFilters[0]

        const waitForElement = () => {
          const element = $(`uds-pill-select.user-filter-${$scope.selectedQuickFilter.id}`)
          if (element.length > 0) {
            element.attr('checked', true)
            api._resetTabObject()
            api._getMyApprovals()
          } else {
            $timeout(waitForElement, 100)
          }
        }

        $scope.$evalAsync(waitForElement)
      }
    })
  }

  function _openEditUserFilterDialog (userFilter) {
    api.getSaveTaskFilterDialogController().then(({ SaveTaskFilterDialogController }) => {
      const saveTaskFilterDialog = UdsModalService.createModal({
        controller: SaveTaskFilterDialogController,
        modalName: 'saveTaskFilterDialog',
        data: {
          selectedFilters: userFilter.filterItems,
          allFilters: $scope.filters,
          editMode: true,
          name: userFilter.name,
          userFilterId: userFilter.id
        },
        onClose: (wasUpdated) => {
          if (wasUpdated) {
            api._getUserFilters()
          }
        }
      })

      saveTaskFilterDialog.open()
    })
  }

  function _openDeleteUserFilterDialog (userFilter) {
    ConfirmationModalService.createModal({
      title: $translate.instant('deleteFilter.title'),
      description: $translate.instant('deleteFilter.description', { filterName: userFilter.name }),
      buttonCancelText: $translate.instant('no'),
      buttonConfirmText: $translate.instant('yesDelete'),
      onConfirm: () => {
        UserFilterService.deleteUserFilter(userFilter.id)
          .then(() => {
            api._getUserFilters()
            ToastService.showSuccessToast($translate.instant('deleteFilter.success', { filterName: userFilter.name }))
          })
          .catch(() => {
            ToastService.defaultErrorToast()
          })
      }
    })
  }
}

export { MyApprovalsTabController }
